import { useState, useEffect, useReducer } from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import { filterReducer } from './hooks'
import { FunctionModal } from 'components/common/Modal'
import { ScrollableBox } from 'components/common/Modal'
import AdvanceFilters from './AdvanceFilters'

const AdvancedFilterSelection = ({
  state,
  dispatch,
  isLarge,
  registerOpenModal,
}) => {
  const [filterModal, setFilterModal] = useState({ open: false })
  const onClose = () => setFilterModal({ open: false })
  const [nameInput, setNameInput] = useState('')
  const [cache, cacheDispatch] = useReducer(filterReducer, state)
  useEffect(() => {
    registerOpenModal(() => setFilterModal({ open: true }))
  }, [registerOpenModal])
  useEffect(() => {
    if (filterModal.open && state !== cache) {
      cacheDispatch({ type: 'REPLACE_ALL', payload: state })
    }
  }, [filterModal.open])

  const onConfirm = () => {
    dispatch({ type: 'SET_FILTER_NAME', payload: nameInput })
    setFilterModal({ open: false })
  }

  const onRemoveFilteredName = () => {
    dispatch({ type: 'REMOVE_FILTER_NAME' })
    setFilterModal({ open: false })
  }

  return (
    <FunctionModal open={filterModal.open}>
      <Box display="flex" flexDirection="column" height="100%">
        <ScrollableBox flexGrow={1} mt={4} mx={4}>
          <AdvanceFilters
            serviceClassificationName={cache?.name}
            serviceClassification={cache.serviceItem}
            advancedFilterItems={cache.advancedFilterItems}
            isLarge={isLarge}
            onRemoveFilteredName={onRemoveFilteredName}
            onSubmitNameInput={(name) => setNameInput(name)}
            onClose={onClose}
            dispatch={cacheDispatch}
          />
        </ScrollableBox>
        <Box p={5}>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Button variant="contained" fullWidth onClick={onConfirm}>
                送出
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </FunctionModal>
  )
}

export default AdvancedFilterSelection
